// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import tippy from 'tippy.js/headless';

export default class TimelineComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = {
      wrapper: null,
      item: [],
      card: [],
      description: []
    }
  }

  mount() { 
    if(this.ref.item.length) {
      for(let i = 0; i < this.ref.item.length; i++) {
        const template = this.ref.card[i].innerHTML;
        // const target = this.ref.popper[i];
        // template.style.display = 'block';

        tippy(this.ref.description[i], {
          content: template,
          animation: true,
          allowHTML: true,
          appendTo: 'parent',
          arrow: false,
          delay: [300, 0],
          interactive: true,
          interactiveBorder: 5,
          placement: 'top-start',
          popperOptions: {
            modifiers: [
              {
                name: 'preventOverflow',
                options: {
                  altAxis: true,
                  tether: false,
                },
              },
            ]
          },
          render(instance) {
            // The recommended structure is to use the popper as an outer wrapper
            // element, with an inner `box` element
            const popper = document.createElement('div');
            const box = document.createElement('div');
        
            popper.appendChild(box);
        
            box.className = 'flex p-5 text-left bg-white shadow-lg w-96 lg:w-[35rem]';
            box.innerHTML = instance.props.content;
        
            function onUpdate(prevProps, nextProps) {
              // DOM diffing
              if (prevProps.content !== nextProps.content) {
                box.innerHTML = nextProps.content;
              }
            }
        
            // Return an object with two properties:
            // - `popper` (the root popper element)
            // - `onUpdate` callback whenever .setProps() or .setContent() is called
            return {
              popper,
              onUpdate, // optional
            };
          },
          onHide(instance) {
            // perform your hide animation in here, then once it completes, call
            // instance.unmount()
        
            // Example: unmounting must be async (like a real animation)
            requestAnimationFrame(instance.unmount);
          },
        });
      }
    }

  }

  
}
